// =============================================================================
// Carousel
// =============================================================================

import 'owl.carousel';

$('document').ready(() => {
    const height = event => {
        const $carousel = $(event.target);
        $carousel.find('.owl-item').css('height', $carousel.height() + 'px');
    };

    $('.carousel').owlCarousel({
        animateIn: 'fadeIn',
        animateOut: 'fadeOut',
        autoplay: true,
        autoplayHoverPause: true,
        dots: true,
        items: 1,
        loop: true,
        callbacks: true,
        onInitialized: height,
        onResize: height,
    });

    $('.ticker').owlCarousel({
        autoplay: true,
        autoplayHoverPause: true,
        dots: false,
        loop: true,
        callbacks: true,
        items: 12,
        autoplayTimeout: 1000,
        slideTransition: 'linear',
        autoplaySpeed: 1000,
        responsive:{
            0: {
              items: 4
            },
            430:{
               items:7
            },
            1024:{
               items:9
            },
            1260:{
               items:10
            },
            1386:{
               items:11
            },
            1512:{
               items:12
            },
            1638:{
               items:13
            },
            1764:{
               items:14
            }
        }

    });
});



// WEBPACK FOOTER //
// ./public/themes/masuri/assets/js/library/Carousel.js